import { takeLatest, select, put, delay } from 'redux-saga/effects';
import * as ACTIONTYPES from '../constants/actiontypes';
import AppConfig from '../../AppConfig';

import {
  loadImages
} from '../actions/imagesLoad';

import {
  getActiveFrame,
  getViewMode,
  getBookType
} from '../selectors/selectors';

const {
  BOOK_TYPES: {
    PHOTO_STORY,
    PHOTO_ILLUSTRATED_BOOK,
  },
  VIEWER_MODES: {
    READ_MODE,
    LISTEN_MODE,
  }
} = AppConfig;

/***************************** Subroutines ************************************/


function* preloadFirstSlides() {
  const state = yield select();
  const activeFrame = getActiveFrame(state);
  const bookType = getBookType(state);

  const isPhotoIlustrated = bookType === PHOTO_ILLUSTRATED_BOOK;
  const isPhotoStory = bookType === PHOTO_STORY;

  if (activeFrame === -1 && (isPhotoIlustrated || isPhotoStory)) {
    if ((isPhotoIlustrated || isPhotoStory)) {
      yield put(loadImages())
    }
  }
}

function* preloadSlides() {
  yield delay(500)
  const state = yield select();
  const bookType = getBookType(state);
  const viewMode = getViewMode(state);

  const isReadMode = viewMode === READ_MODE;
  const isListenMode = viewMode === LISTEN_MODE;
  const isPhotoIlustrated = bookType === PHOTO_ILLUSTRATED_BOOK;

  if (isPhotoIlustrated) {
    if (!isListenMode) {
      yield put(loadImages())
    }
  } else {
    if (isReadMode) {
      yield put(loadImages())
    }
  }
}



/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchAddBook() {
  yield takeLatest(
    ACTIONTYPES.ADD_BOOK,
    preloadFirstSlides
  )
}

export function* watchChangeMode() {
  yield takeLatest(
    ACTIONTYPES.CHANGE_VIEW_MODE,
    preloadSlides
  )
}

export function* watchChangeFrame() {
  yield takeLatest(
    ACTIONTYPES.CHANGE_ACTIVE_FRAME,
    preloadSlides
  )
}


// WEBPACK FOOTER //
// ./src/store/sagas/preloading-slides.js